module.exports = __webpack_public_path__ + "media/images/favicon/favicon@mask-icon-1d579e0a5f1be749032dad926c7f61a4.svg";